import * as React from "react";
import { ActionUsagesModal } from "../design-tools/left-panel/datasource-panel/action-usages-modal";
import KuikaButton from "../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../ui-kit/kuika-svg/kuika-svg";
import "./action-usages-button.scss";

export interface IActionUsagesButtonProps {
  /** The action-definition id being edited. Nothing renders while an action is still being created. */
  actionId: string | undefined;
  actionName?: string;
}

export interface IActionUsagesButtonState {
  isModalVisible: boolean;
}

/**
 * KOA-17818 — the "Where Used" entry point inside an action editor, so the impact of a change can
 * be checked before the change is saved. Owns its own modal state so the two editors that mount it
 * (SQL action, Select action) do not each have to carry a copy.
 *
 * Renders nothing for a brand-new action: there is nothing to have an impact on yet.
 */
export class ActionUsagesButton extends React.PureComponent<IActionUsagesButtonProps, IActionUsagesButtonState> {
  constructor(props: IActionUsagesButtonProps) {
    super(props);
    this.state = { isModalVisible: false };
  }

  openModal = (): void => {
    this.setState({ isModalVisible: true });
  };

  closeModal = (): void => {
    this.setState({ isModalVisible: false });
  };

  render(): React.ReactNode {
    if (!this.props.actionId) {
      return null;
    }

    return (
      <div className="kuika-action-usages-button">
        <KuikaButton type="tertiary" color="neutral" size="sm" onClick={this.openModal}>
          <KuikaSvg width={16} height={16} name="list-search" />
          Where Used
        </KuikaButton>
        <ActionUsagesModal
          showModal={this.state.isModalVisible}
          closeModal={this.closeModal}
          actionId={this.props.actionId}
          actionName={this.props.actionName}
        />
      </div>
    );
  }
}
